import React from "react";

export default function Play() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.1564 20C30.1564 20.7852 29.8283 21.5235 29.2541 22.0625L16.1289 34.2501C15.3086 35.0118 14.1133 35.2111 13.0938 34.7657C12.0742 34.3204 11.4062 33.3009 11.4062 32.1876L11.4062 7.8124C11.4062 6.69911 12.0742 5.67957 13.0938 5.23425C14.1133 4.78894 15.3086 4.98816 16.1289 5.74988L29.2541 17.9375C29.8283 18.4648 30.1564 19.2148 30.1564 20Z"
        fill="#123333"
      />
    </svg>
  );
}
